module.exports = __webpack_public_path__ + "img/dewarp-before.3d2507a8.webp";